import { helper } from '@ember/component/helper';

/**
 * Resolves a numeric judgement string to its display label using the subject's possibleGrades.
 *
 * Usage (live): {{reporting/judgement-label studentSection.judgement subject.possibleGrades}}
 * Usage (snapshot-first): {{reporting/judgement-label studentSection.judgement subject.possibleGrades snapshotLabel}}
 *
 * When `snapshotLabel` is non-empty it is returned verbatim — this is the
 * publish-snapshot path where the backend has already resolved the
 * judgement against the subject's possibleGrades at publish time. Falls
 * back to live possibleGrades resolution otherwise.
 */
export default helper(function judgementLabel([
  judgementValue,
  possibleGrades,
  snapshotLabel,
]) {
  if (snapshotLabel) return snapshotLabel;
  if (judgementValue == null || judgementValue === '') {
    return null;
  }
  let grades = possibleGrades || [];
  let numeric = parseInt(judgementValue, 10);
  let entry = grades.find((g) => g.value === numeric);
  return entry ? entry.string : null;
});
